import { Component, OnInit, OnDestroy, Input, EventEmitter, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.state';
import { LogActivityService } from 'src/app/services/settings-services/log-activity.service';

@Component({
  selector: 'app-log-feeds-list',
  templateUrl: './log-feeds-list.component.html',
  styleUrls: ['./log-feeds-list.component.css']
})
export class LogFeedsListComponent {

  user;
  @Input() activity; // decorate the property with @Input()
  @Output() newItemEvent = new EventEmitter<string>();

  constructor(
    private logSrv: LogActivityService,
    store: Store<AppState>
  ) {
    store.select("userInfo").subscribe(info => {
      this.user = info.user.id;
    });
  }

  viewSingleActivity(value: any) {
    this.logSrv.logItem.next(value);
  }


}
